module.exports = __webpack_public_path__ + "static/media/create-account-lock.d3ae84ae.svg";